import Icon from "../Icon/Icon";
import IconError from "../Icon/IconError";
import IconInfo from "../Icon/IconInfo";
import IconSuccess from "../Icon/IconSuccess";

const AlertIcon: React.FC<AlertIconProps> = ({ type, className, icon }) => (
  <Icon type={type} className={className}>
    {icon}
    {!icon && type === "success" && <IconSuccess />}
    {!icon && type === "error" && <IconError />}
    {!icon && type === "info" && <IconInfo />}
    {!icon && type === "muted" && <IconInfo />}
    {!icon && type === "warn" && <IconInfo />}
  </Icon>
);

export type AlertIconProps = {
  type: "success" | "error" | "info" | "warn" | "muted";
  className?: string;
  icon?: React.ReactNode;
};

export default AlertIcon;
